import React, { useEffect } from 'react';
import './Emteslla.css';
import Footer from './Footer';

const Emteslla = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="Emteslla-container">

      {/* Hero Section */}
      <section className="Emteslla-hero">
        <div className="Emteslla-hero-image-wrapper">
          <img src="/Emteslla.jpg" alt="Emteslla Treatment" className="Emteslla-hero-img" />
          <div className="Emteslla-hero-overlay"></div>
        </div>
        <div className="Emteslla-hero-content">
          <div className="Emteslla-hero-tag">Advanced Technology</div>
          <h1 className="Emteslla-hero-title">
            EMTESLLA
          </h1>
          <div className="Emteslla-hero-line"></div>
          <p className="Emteslla-hero-subtitle">Deep Pelvic Floor Muscle Stimulation & Restoration</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="Emteslla-content">
        <div className="Emteslla-content-inner">

          {/* Statement Section */}
          <div className="Emteslla-statement">
            <h2 className="Emteslla-statement-title">
              How Does <span className="Emteslla-highlight">It Work?</span>
            </h2>
            <div className="Emteslla-statement-divider"></div>
            <p className="Emteslla-statement-text">
              It causes deep pelvic floor muscle stimulation & restoration of neuromuscular control.
              A single Emteslla session brings thousands of supramaximal pelvic floor muscle contractions
              which are extremely important in muscle re-education of women after child birth,
              post prostate surgery, post menopausal women & Stress/Urge urinary incontinence.
            </p>
          </div>

          {/* Benefits Section */}
          <div className="Emteslla-benefits">
            <div className="Emteslla-benefit-card">
              <div className="Emteslla-benefit-number">01</div>
              <div className="Emteslla-benefit-body">
                <h3>Post Childbirth Recovery</h3>
                <p>Muscle re-education and pelvic floor strengthening for women after delivery, restoring core stability and control.</p>
              </div>
            </div>

            <div className="Emteslla-benefit-card">
              <div className="Emteslla-benefit-number">02</div>
              <div className="Emteslla-benefit-body">
                <h3>Post Prostate Surgery</h3>
                <p>Targeted neuromuscular restoration helping regain pelvic floor function and control after surgical procedures.</p>
              </div>
            </div>

            <div className="Emteslla-benefit-card">
              <div className="Emteslla-benefit-number">03</div>
              <div className="Emteslla-benefit-body">
                <h3>Post Menopausal Support</h3>
                <p>Strengthening weakened pelvic floor muscles that naturally deteriorate with hormonal changes during menopause.</p>
              </div>
            </div>

            <div className="Emteslla-benefit-card">
              <div className="Emteslla-benefit-number">04</div>
              <div className="Emteslla-benefit-body">
                <h3>Urinary Incontinence</h3>
                <p>Effective treatment for both stress and urge urinary incontinence through deep muscle stimulation and neuromuscular control.</p>
              </div>
            </div>
            <div className="Emteslla-benefit-card">
              <div className="Emteslla-benefit-number">05</div>
              <div className="Emteslla-benefit-body">
                <h3>Erectile Dysfunction</h3>
                <p>Targeted neuromuscular restoration helping to improve pelvic floor function and control in men with erectile dysfunction.</p>
              </div>
            </div>

            <div className="Emteslla-benefit-card">
              <div className="Emteslla-benefit-number">06</div>
              <div className="Emteslla-benefit-body">
                <h3>Uterine Prolapse</h3>
                <p>Targeted neuromuscular restoration helping to improve pelvic floor function and control in women with uterine prolapse.</p>
              </div>
            </div>
          </div>

          {/* Key Benefits Section */}
          <div className="Emteslla-key-benefits">
            <h2 className="Emteslla-section-heading">
              Key <span className="Emteslla-highlight">Benefits</span>
            </h2>

            <div className="Emteslla-kb-grid">
              <div className="Emteslla-kb-card">
                <div className="Emteslla-kb-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M22 12h-4l-3 9L9 3l-3 9H2"/>
                  </svg>
                </div>
                <h3>High Intensity Pelvic Floor Exercise</h3>
                <p>Delivers powerful, targeted muscle contractions that strengthen the pelvic floor. Ideal for improving core stability, bladder control, and overall pelvic health.</p>
              </div>

              <div className="Emteslla-kb-card">
                <div className="Emteslla-kb-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
                  </svg>
                </div>
                <h3>Non Invasive</h3>
                <p>A completely contactless procedure with no needles, probes, or downtime. Enjoy effective results without any physical discomfort or recovery time.</p>
              </div>

              <div className="Emteslla-kb-card">
                <div className="Emteslla-kb-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
                  </svg>
                </div>
                <h3>Remain Fully Clothed</h3>
                <p>No need to change or undress — simply sit on the chair and relax. The treatment works through your clothing, offering comfort and privacy.</p>
              </div>

              <div className="Emteslla-kb-card">
                <div className="Emteslla-kb-icon">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                    <circle cx="9" cy="7" r="4"/>
                    <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                    <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                  </svg>
                </div>
                <h3>Suitable For Everyone</h3>
                <p>Safe for all ages, genders, and fitness levels, with no special preparation required. Whether for postnatal care or aging support, it's highly effective.</p>
              </div>
            </div>
          </div>

        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Emteslla;
